var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ws-row",class:{center:_vm.isCenter,right:_vm.isRight,blue: _vm.blue},style:({'max-width': _vm.maxWidth})},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }